/**
 * @generated SignedSource<<250d7331256a248bb015d9a2aef74fb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackCardActionsDeleteDraftMutation$variables = {
  id: string;
};
export type FeedbackCardActionsDeleteDraftMutation$data = {
  readonly deleteDraftFeedback: {
    readonly deletedId: string;
  } | null;
};
export type FeedbackCardActionsDeleteDraftMutation = {
  response: FeedbackCardActionsDeleteDraftMutation$data;
  variables: FeedbackCardActionsDeleteDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackCardActionsDeleteDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftFeedback",
        "kind": "LinkedField",
        "name": "deleteDraftFeedback",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedbackCardActionsDeleteDraftMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteDraftFeedback",
        "kind": "LinkedField",
        "name": "deleteDraftFeedback",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0d4aefb6afaa48963699ee042e8c93d",
    "id": null,
    "metadata": {},
    "name": "FeedbackCardActionsDeleteDraftMutation",
    "operationKind": "mutation",
    "text": "mutation FeedbackCardActionsDeleteDraftMutation(\n  $id: ID!\n) {\n  deleteDraftFeedback(id: $id) {\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9138cf465c39ac4b0ec70a3c34505a42";

export default node;
